import { Shield, Lock, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

export const TrustIndicators = () => {
  return (
    <div className="mt-6 space-y-4">
      {/* Security badges */}
      <div className="flex items-center justify-center gap-6 text-xs text-muted-foreground">
        <div className="flex items-center gap-1.5">
          <Shield className="w-3.5 h-3.5 text-primary" />
          <span>Secure & Encrypted</span>
        </div>
        <div className="flex items-center gap-1.5">
          <Lock className="w-3.5 h-3.5 text-primary" />
          <span>Privacy Protected</span>
        </div>
        <div className="flex items-center gap-1.5">
          <CheckCircle2 className="w-3.5 h-3.5 text-primary" />
          <span>Verified Secure</span>
        </div>
      </div>

      {/* Legal links */}
      <div className="text-center text-xs text-muted-foreground">
        By continuing, you agree to our{' '}
        <Link to="/terms" className="text-primary hover:underline font-medium">
          Terms of Service
        </Link>
        {' '}and{' '}
        <Link to="/privacy" className="text-primary hover:underline font-medium">
          Privacy Policy
        </Link>
      </div>

      {/* Social proof */}
      <div className="text-center">
        <p className="text-xs text-muted-foreground">
          Trusted by thousands of customers worldwide
        </p>
      </div>
    </div>
  );
};
